module.exports = __webpack_public_path__ + "static/img/W_SHOES.78c94fc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/W_SHOES.jpg
// module id = vKAS
// module chunks = 1